import React from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'react-router-dom';
import { Layout } from 'antd/lib';

import RutaAutenticada from '../auth/RutaAutenticada';
import GenerarCaso from './casos/GenerarCaso';
import ListarCasos from './casos/ListarCasos';
import AgregarMedida from './casos/AgregarMedida';
import VerCaso from './casos/VerCaso';
import IngresarDatos from './casos/formularios/IngresarDatos';
import ReporteCasos from './casos/ReporteCasos';

class Index extends React.PureComponent {
  render() {
    const { Content } = Layout;

    return (
      <Layout
        style={{
          padding: '0 24px 24px',
        }}
      >
        <Content
          style={{
            padding: '0 24px 24px 24px',
            margin: 0,
          }}
        >
          <Switch>
            <RutaAutenticada
              exact
              path={`${this.props.match.url}/evaluarCaso`}
              component={GenerarCaso}
              // rolesAutorizados={[
              //   Roles.MESA_DE_ENTRADA,
              //   Roles.DESPACHO,
              //   Roles.FUNCIONARIO,
              //   Roles.SUPERVISOR
              // ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/listarCasos`}
              component={ListarCasos}
              // rolesAutorizados={[
              //   Roles.MESA_DE_ENTRADA,
              //   Roles.DESPACHO,
              //   Roles.FUNCIONARIO,
              //   Roles.SUPERVISOR
              // ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/reporteCasos`}
              component={ReporteCasos}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/:id/agregarMedida/`}
              component={AgregarMedida}
              // rolesAutorizados={[
              //   Roles.MESA_DE_ENTRADA,
              //   Roles.DESPACHO,
              //   Roles.FUNCIONARIO,
              //   Roles.SUPERVISOR
              // ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/caso/:id/`}
              component={VerCaso}
              // rolesAutorizados={[
              //   Roles.MESA_DE_ENTRADA,
              //   Roles.DESPACHO,
              //   Roles.FUNCIONARIO,
              //   Roles.SUPERVISOR
              // ]}
            />

            <RutaAutenticada
              exact
              path={`${this.props.match.url}/caso/:id/registrarEvaluacion`}
              component={IngresarDatos}
              // rolesAutorizados={[
              //   Roles.MESA_DE_ENTRADA,
              //   Roles.DESPACHO,
              //   Roles.FUNCIONARIO,
              //   Roles.SUPERVISOR
              // ]}
            />
          </Switch>
        </Content>
      </Layout>
    );
  }
}

Index.propTypes = {
  match: PropTypes.object.isRequired,
};

export default Index;
